import { db } from '../../firebase'
import { PRE_REGISTER } from '../Collections'

const preRegisterRef = db.collection(PRE_REGISTER)

export const get = email => preRegisterRef.doc(email).get()
